module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-prismic-previews/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"doing-things","accessToken":"MC5ad1JLOFJFQUFDd0Fiazlv.77-977-9JWHvv73vv73vv73vv73vv73vv71BGgxoYkIRPzzvv71_Bgjvv73vv73vv73vv71CRTDvv71_"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
